import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Layout from '../Layout/index';
import MainWrapper from './MainWrapper';

import LogIn from '../LogIn/index';
import ExamplePageOne from '../Example/index';
import ExamplePageTwo from '../ExampleTwo/index';
import OpenOrders from '../Fulfillment/OpenOrders/index';
import AllOrders from '../Fulfillment/AllOrders/index';
import DiscogsFulfilments from '../Fulfillment/Discogs/Fulfilments/index';
import NewItems from '../Inventory/NewItems/index';
import AmazonOrders from '../Orders/Amazon/index';
import EbayOrders from '../Orders/Ebay/index';
import DiscogsOrders from '../Orders/Discogs/index';
import Purchases from '../Orders/Purchases/index';
import PurchaseManagement from '../Orders/PurchaseManagement/index';
import AboveBoardBandcampOrders from '../AboveBoard/Orders/BandCamp/index';
import AboveBoardBandcampOrdersDhl from '../AboveBoard/Orders/BandCampDhl/index';
import MerchItems from '../AboveBoard/Merch/index';
import Returns from '../AboveBoard/Orders/Returns/index';
import ShippingDhl from '../Shipping/DHL/index';
import Shipments from '../Shipping/Shipments/index';
import ManageShipments from '../Shipping/ManageShipments/index';
import ShipmentHistory from '../Shipping/ShipmentHistory/index';
import ShippingToolsEbay from '../Tools/Shipping/Ebay/index';
import ShippingToolsAmazon from '../Tools/Shipping/Amazon/index';
import ShippingToolsFulfilment from '../Tools/Shipping/Fulfilment/index';
import ShippingToolsAboveBoard from '../Tools/Shipping/AboveBoard/index';
import ToolsUpdateOrders from '../Tools/Updates/index';
import ToolsManageSellers from '../Tools/SellerManagement/index';
import ToolsManageClients from '../Tools/ClientManagement/index';
import ToolsReportingOrders from '../Tools/Reporting/Orders/index';
import TintsDirectOrders from '../TintsDirect/Orders/index';
import TintsDirectActions from '../TintsDirect/Actions/index';
import ShopifyOrders from '../Fulfillment/Shopify/Orders/index';
import ShopifyActions from '../Fulfillment/Shopify/Actions/index';
import ShopifyStock from '../Fulfillment/Shopify/Stock/index';
import ShopifyFulfilments from '../Fulfillment/Shopify/Fulfilments/index';


import BandcampOrders from '../Fulfillment/Bandcamp/Orders/BandCamp/index';
import BandcampOrdersDHL from '../Fulfillment/Bandcamp/Orders/BandCampDhl/index';
import BandcampMerchItems from '../Fulfillment/Bandcamp/Merch/index';
import BandcampActions from '../Fulfillment/Bandcamp/Actions/index';
import BandcampFulfilments from '../Fulfillment/Bandcamp/Fulfilments/index';


const Pages = () => (
  <Switch>
    <Route path="/pages/one" component={ExamplePageOne} />
    <Route path="/pages/two" component={ExamplePageTwo} />
  </Switch>
);

const Fulfillment = () => (
  <Switch>
    <Route path="/fulfillment/orders" component={OpenOrders} />
    <Route path="/fulfillment/allorders" component={AllOrders} />
    <Route path="/fulfillment/discogs/fulfilments" component={DiscogsFulfilments} />
    <Route path="/fulfillment/bandcamp/orders" component={BandcampOrders} />
    <Route path="/fulfillment/bandcampdhl/orders" component={BandcampOrdersDHL} />
    <Route path="/fulfillment/bandcamp/merch" component={BandcampMerchItems} />
    <Route path="/fulfillment/bandcamp/fulfilments" component={BandcampFulfilments} />
    <Route path="/fulfillment/bandcamp/actions" component={BandcampActions} />

    <Route path="/fulfillment/shopify/orders" component={ShopifyOrders} />
    <Route path="/fulfillment/shopify/fulfilments" component={ShopifyFulfilments} />
    <Route path="/fulfillment/shopify/actions" component={ShopifyActions} />
    <Route path="/fulfillment/shopify/stock" component={ShopifyStock} />
  </Switch>
);

const Inventory = () => (
  <Switch>
    <Route path="/inventory/new_items" component={NewItems} />
  </Switch>
);

const Orders = () => (
  <Switch>
    <Route path="/orders/amazon" component={AmazonOrders} />
    <Route path="/orders/ebay" component={EbayOrders} />
    <Route path="/orders/discogs" component={DiscogsOrders} />
    <Route path="/orders/purchases/new" component={Purchases} />
    <Route path="/orders/purchases" component={PurchaseManagement} />

  </Switch>
);

const AboveBoard = () => (
  <Switch>
    <Route path="/aboveboard/orders/bandcamp" component={AboveBoardBandcampOrders} />
    <Route path="/aboveboard/orders/bandcampdhl" component={AboveBoardBandcampOrdersDhl} />
    <Route path="/aboveboard/orders/returns" component={Returns} />
    <Route path="/aboveboard/merch" component={MerchItems} />
  </Switch>
);

const TintsDirect = () => (
  <Switch>
    <Route path="/tintsdirect/actions/index" component={TintsDirectActions} />
    <Route path="/tintsdirect/orders/index" component={TintsDirectOrders} />
  </Switch>
);

const Shipping = () => (
  <Switch>
    <Route path="/shipping/dhl" component={ShippingDhl} />
    <Route path="/shipping/shipments" component={Shipments} />
    <Route path="/shipping/manageshipments" component={ManageShipments} />
    <Route path="/shipping/history" component={ShipmentHistory} />
  </Switch>
);

const Tools = () => (
  <Switch>
    <Route path="/tools/orders/update" component={ToolsUpdateOrders} />
    <Route path="/tools/shipping/ebay" component={ShippingToolsEbay} />
    <Route path="/tools/shipping/amazon" component={ShippingToolsAmazon} />
    <Route path="/tools/shipping/fulfilment" component={ShippingToolsFulfilment} />
    <Route path="/tools/shipping/aboveboard" component={ShippingToolsAboveBoard} />
    <Route path="/tools/reporting/orders" component={ToolsReportingOrders} />
    <Route path="/tools/sellers/manage" component={ToolsManageSellers} />
    <Route path="/tools/clients/manage" component={ToolsManageClients} />
  </Switch>
);

const wrappedRoutes = () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <Route path="/pages" component={Pages} />
      <Route path="/fulfillment" component={Fulfillment} />
      <Route path="/inventory" component={Inventory} />
      <Route path="/orders" component={Orders} />
      <Route path="/aboveboard" component={AboveBoard} />
      <Route path="/tintsdirect" component={TintsDirect} />
      <Route path="/shipping" component={Shipping} />
      <Route path="/tools" component={Tools} />
    </div>
  </div>
);

const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route exact path="/" component={LogIn} />
        <Route exact path="/log_in" component={LogIn} />
        <Route path="/" component={wrappedRoutes} />
      </Switch>
    </main>
  </MainWrapper>
);

export default Router;
